
import { defineComponent } from 'vue';
import { primitiveMessages, useNodeCanvasStore } from '../store';
import { removeElement } from '@/modules/globalModule/components/helperMethods';
import SearchableDropDown from '@/modules/globalModule/components/SearchableDropDown.vue';
import { Message, MessageField } from './storeClasses/message';
import { useGlobalStore } from '@/modules/globalModule/store';
import { copyFileSync } from 'fs';

interface State {
  ncStore: any;
  allMessages: Array<Message>;
  globalStore: any;
  editModeParams: Array<string>; // array of ServiceParamer ids
  constParams: Array<string>;
}

export default defineComponent({
  name: 'EditServiceBox',
  emits: ['editServiceEnd'],
  data(): State {
    return {
      allMessages: [],
      globalStore: useGlobalStore(),
      ncStore: useNodeCanvasStore(),
      editModeParams: [],
      constParams: []
    };
  },
  components: {
    SearchableDropDown
  },
  created() {
    if (this.ncStore.editingService === undefined) {
      this.onExitModal();
    }
  },
  mounted() {
    const globalStore = useGlobalStore();
    this.allMessages = globalStore.getMessages();
  },
  methods: {
    onExitModal() {
      this.$emit('editServiceEnd');
      this.ncStore.editingService = undefined;
      this.editModeParams = [];
    },
    save() {
      this.$emit('editServiceEnd');
    },
    getPrimitiveMessages() {
      return primitiveMessages;
    },
    /**
     * @param request true if adding to request list, false if response list
     */
    addNewParam(request: boolean) {
      const newParam: MessageField = new MessageField(
        primitiveMessages[0].id,
        ''
      );
      if (request) {
        this.ncStore.editingService.requestList.push(newParam);
      } else {
        this.ncStore.editingService.responseList.push(newParam);
      }
    },
    onEditParam(request: boolean, id: string) {
      if (this.editModeParams.includes(id)) {
        removeElement(this.editModeParams, id);
        if (this.constParams.includes(id)) removeElement(this.constParams, id);
        return;
      }
      this.editModeParams.push(id);
      if (
        request &&
        this.ncStore.editingService.requestList.find(
          (param: MessageField) => param.id === id
        ).constantValue !== undefined
      ) {
        this.constParams.push(id);
      } else if (
        !request &&
        this.ncStore.editingService.responseList.find(
          (param: MessageField) => param.id === id
        ).constantValue !== undefined
      ) {
        this.constParams.push(id);
      }
    },
    onDup(id: string) {},
    onDeleteParam(request: boolean, id: string) {
      if (request) {
        this.ncStore.editingService.requestList =
          this.ncStore.editingService.requestList.filter(
            (param: MessageField) => param.id !== id
          );
      } else {
        this.ncStore.editingService.responseList =
          this.ncStore.editingService.responseList.filter(
            (param: MessageField) => param.id !== id
          );
      }
    },
    /**
     *
     * @param request - true if request, false if response
     * @param id - id of the message field to change
     * @param msg - new message type to change to
     */
    chooseParamMsgType(request: boolean, id: string, msg: Message) {
      if (!msg) return;
      if (request) {
        this.ncStore.editingService.requestList.find(
          (reqParam: MessageField) => reqParam.id === id
        )!.msg = msg.id;
      } else {
        this.ncStore.editingService.responseList.find(
          (resParam: MessageField) => resParam.id === id
        )!.msg = msg.id;
      }
    },
    onConstBoxClicked(param: MessageField) {
      if (param.constantValue === undefined) param.constantValue = '';
      else {
        param.constantValue = undefined;
        if (this.constParams.includes(param.id))
          removeElement(this.constParams, param.id);
      }
    },
    getParamTypeString(param: MessageField) {
      const globalStore = useGlobalStore();
      const msgType = globalStore.getMessage(param.msg);
      if (!msgType) return '';
      return msgType.name;
    },
    openCode() {
      this.save();
      this.$router.push(
        `/codeView/${this.$route.params.workspaceID}?elemId=${this.ncStore.editingService.id}`
      );
    }
  }
});
